import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { TipoDocumentos } from '../models/tipo-documento.model';
import { Parentescos } from '../models/parentesco.model';
import { Solicitantes } from '../models/solicitante.model';
import { environment } from 'src/environments/environment';
import { ParametrosGc } from '../models/parametros-gc.model';
import { DocumentosParentesco } from '../models/docs-parentesco.model';
import { Retorno } from '../models/retorno.model';
import { Tipos } from '../models/tipos';
import { BandejaDocumento, BandejaDocumentos } from '../models/bandeja-documentos';
import { ArchivoDocumento, DocumnetoAdjunto, ResponseBack, RespuestaProcedimiento } from '../models/archivo-documento';
import { Bandeja, BandejaSolicitante } from '../models/bandeja';

@Injectable({
  providedIn: "root",
})
export class ParametroApiService {
  financiamiento = "/consulta";
  //httpOptions; any;
  private SERVER_URL = environment.api;

  constructor(private httpClient: HttpClient) { }

  consultarParametro(codigo: string, subcodigo: string) {
    let params: HttpParams = new HttpParams();
    params = params.set('codigo', codigo);
    params = params.set('subcodigo', subcodigo);
    return this.httpClient.get(this.SERVER_URL + `/consulta/parametro`, { params });
  }

}
